import { Controller, useFormContext } from "react-hook-form";
import { DatePickerFormprop } from "./DatePickerProps";
import { forwardRef, useCallback, useState } from "react";
import moment, { months } from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { FormControl, FormHelperText, TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
const localeMap = (language) => {
    moment.updateLocale('en', {
        months: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม",
            "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
        weekdaysMin: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],//["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์"],
        weekdays: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"],
        weekdaysShort: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"]
    });

};

/** class CustomAdapter */
class CustomAdapter extends AdapterMoment {
    constructor({ locale, formats, instance }) {
        super({ locale, formats, instance });
    }

    calYear(moment) {
        switch (this.locale) {
            case "th":
                return (parseInt(moment.format('YYYY')) + 543).toString();
            // return (parseInt(moment.format('YYYY'))).toString();
            case "en":
                return parseInt(moment.format('YYYY'));
            default:
                return parseInt(moment.format('YYYY'));
        }
    }
    renderLabel(moment, format) {
        switch (format) {
            case "year":
                return this.calYear(moment);
            case "month":
                return moment.format("MMMM");
            case "fullDate":
                return moment.format("DDMMYYYY");
            case "dayOfMonth":
                return moment.format("D");
            case "monthShort":
                return moment.format("MMMM");
            case "monthAndYear":
                return `${moment.format("MMMM")} ${this.calYear(moment)}`;
            case "normalDate":
                return `${moment.format("dd")} ${moment.format("MMM")} ${moment.format("D")}`;
            default:
                return moment.format(format);
        }
    }
    startOfMonth = (date) => date ? date.clone().startOf("month") : moment(new Date());

    format = (date, formatKey) => {
        return date ? this.renderLabel(date, formatKey) : moment(new Date());
    };
}

class CustomAdapterDateFns extends AdapterDateFns {
    constructor({ formats }) {
        super({ formats });
    }
    renderLabel(moment, format) {
        //console.log("format", format);

        switch (format) {
            case "year":
                return moment.format("YYYY");
            case "month":
                return moment.format("MMMM");
            case "dayOfMonth":
                return moment.format("D");
            case "monthShort":
                return moment.format("MMM");
            case "monthAndYear":
                return moment.format("MMMM YYYY");
            case "weekday":
                return moment.format("DD");
            default:
                return moment.format(format);
        }
    }

    format = (date, formatKey) => {
        //console.log("format", date);
        return this.renderLabel(moment(date), formatKey);
    };
}
export const DatePickerFromItem = forwardRef((props: DatePickerFormprop, ref) => {

    const { name, fullWidth = false, format = "DD/MM/YYYY",
        arrDisableMonth = [],
        defaultCalendarMonth = undefined,
    } = props;
    const minDate = props.minDate || null;
    const maxDate = props.maxDate || null;
    const required = props.required ?? false;
    const disabled = props.disabled ?? false;
    const view = props.view ?? ['year', 'month', 'day'];
    const { control, } = useFormContext();
    const formatDefalut = defaultCalendarMonth ? "dd/MM/yyyy" : format;
    const [open, setOpen] = useState(false);
    const [locale, setLocale] = useState("th");

    /** funtion */

    const ReplaceThFormat = (text) => {
        return text ? text.toLowerCase().replaceAll("d", "ว").replaceAll("m", "ด").replaceAll("y", "ป") : "";
    }

    const maskMap = {
        en: formatDefalut,
        th: ReplaceThFormat(formatDefalut),
    };

    const [objCheckReplace] = useState(() => {
        localeMap(locale);
        let objReturn = { isReplaceYear: false, indexArr: 0, splitText: "" };
        let formatLower = formatDefalut ? formatDefalut.toLowerCase() : "";
        if (formatLower.includes("YYYY")) {
            let splitText = (formatDefalut.substr(formatLower.indexOf("YYYY") - 1, 1)).toLowerCase();
            if (splitText !== "Y") {
                objReturn.splitText = splitText;
                objReturn.indexArr = formatLower.split(splitText).findIndex((e) => e === "YYYY");
            }
            objReturn.isReplaceYear = true;
        }
        return objReturn;
    });

    const getmoment = useCallback((params, value) => {
        if (locale === "th") {
            if (value != null && objCheckReplace.isReplaceYear && format.length === 10) {
                let convertDateToString: string = moment(value).format(format);
                let year = objCheckReplace.splitText ? convertDateToString.split(objCheckReplace.splitText)[objCheckReplace.indexArr] : convertDateToString.substr(0, 4);
                let addyear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
                let replaceAllFormat = format.replaceAll("YYYY", "");
                params.inputProps.value = moment(value).format(replaceAllFormat) + addyear;
            }
            else if (format === "YYYY" && value != null && objCheckReplace.isReplaceYear) {
                let convertDateToString: string = moment(value).format(format);
                let addyear = parseInt(convertDateToString) > 2500 ? parseInt(convertDateToString) : parseInt(convertDateToString) + 543;
                params.inputProps.value = addyear.toString();

            }
            else if (format === "MM/YYYY" && value != null && objCheckReplace.isReplaceYear) {
                let convertDateToString: string = moment(value).format(format);
                let year = objCheckReplace.splitText ? convertDateToString.split(objCheckReplace.splitText)[1] : convertDateToString.substr(0, 2);
                let addyear = parseInt(year) > 2500 ? parseInt(year) : parseInt(year) + 543;
                params.inputProps.value = convertDateToString.replaceAll(`${year}`, `${addyear}`);
            }
        }
    }, [])

    const isNextMonth = (date) => {
        if (arrDisableMonth && arrDisableMonth.length > 0) {
            const startOfNextMonth = date.getMonth() + 1 //moment(date).format("M");
            if (arrDisableMonth.some(f => (f + "") == (startOfNextMonth + ""))) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    const isNextDay = (date) => {

        if (maxDate && date > maxDate) {
            return true;
        } else {
            if (arrDisableMonth && arrDisableMonth.length > 0) {
                const startOfNextMonth = date.getMonth() + 1 //moment(date).format("M");
                if (arrDisableMonth.some(f => (f + "") == (startOfNextMonth + ""))) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    };

    const isNextYear = (date) => {
        if (maxDate && date > maxDate) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, onBlur, value, ref },
                fieldState: { invalid, error }, }) => (
                <LocalizationProvider
                    adapterLocale={"th"}
                    dateAdapter={CustomAdapter}
                >
                    <FormControl
                        fullWidth={fullWidth}
                        sx={{
                            "label.MuiInputLabel-shrink": {
                                backgroundColor: disabled ? "#E9E8E8" : "#FFF",
                                top: "0px",
                            },
                            ".MuiInputLabel-outlined": {
                                top: "0px",
                            },
                            ".MuiInputLabel-asterisk": {
                                color: "red"
                            }
                        }}
                    >
                        <DatePicker
                            key={name}
                            shouldDisableMonth={(e) => isNextMonth(e)}
                            shouldDisableDate={isNextDay}
                            shouldDisableYear={isNextYear}
                            dayOfWeekFormatter={(day) => day.charAt(0).toUpperCase() === "เ" ? "ส" : day.charAt(0).toUpperCase()}
                            inputRef={ref}
                            value={value ? moment(value, formatDefalut) : null}
                            onChange={(e, key) => {
                                let s = moment(e).isValid();
                                if (s !== false) {
                                    let dInfo: Date = e;
                                    onChange(dInfo);
                                    props.onChange && props.onChange(dInfo);
                                }
                                else {
                                    onChange(null);
                                    props.onChange && props.onChange(null);
                                }
                            }}
                            open={open}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                            minDate={minDate}
                            maxDate={maxDate}
                            label={props.label}
                            inputFormat={formatDefalut}
                            openTo={props.openTo || "year"}
                            defaultCalendarMonth={defaultCalendarMonth}
                            disabled={disabled}
                            views={defaultCalendarMonth ? ["day"] : view}
                            showToolbar={false}
                            DialogProps={{ sx: { '& .PrivateDatePickerToolbar-penIcon,& .MuiPickersToolbar-penIconButton': { display: 'none' } } }}
                            renderInput={(params) => {
                                params.inputProps.placeholder = maskMap[locale];
                                getmoment(params, value)
                                let _refvalue = moment(params.inputProps.value,"DD/MM/YYYY");
                                if (_refvalue.isValid()) {
                                    params.inputProps.value = _refvalue.format("DD/MM") + "/" + (_refvalue.year() + 543);
                                } else {
                                    if (params.inputProps.value) {
                                        let va = (params.inputProps.value + "").split('/');
                                        params.inputProps.value = va[0] + "/" + va[1] + "/" + ((+va[2]) + 543);
                                    }
                                }
                                return (
                                    <TextField
                                        {...params}

                                        sx={{
                                            ".MuiOutlinedInput-root": {
                                                padding: "0px 15px 0px 0px!important",
                                                marginLeft: "0px",
                                                " fieldset > legend > span": {
                                                    padding: "0px !important",
                                                },

                                            },
                                            fontWeight: 600,
                                        }}
                                        size={"small"}
                                        label={props.label}
                                        name={name}
                                        error={error?.message != null}
                                        required={required}
                                        disabled={disabled}
                                        id={name}
                                        autoComplete={"off"}
                                        onClick={(e) => setOpen(true)}
                                    />
                                )
                            }}
                        />
                        {error ? (
                            <FormHelperText sx={{ color: "red", marginLeft: "0px" }}>
                                {error.message}
                            </FormHelperText>
                        ) : null}
                    </FormControl>
                </LocalizationProvider>
            )
            }
        />
    );

});
